const getLexicalDependencies = (value, key, opts = {}) => {
  if (value === null) {
    return [];
  }

  const extractStepIds = (node) => {
    if (!node || typeof node !== 'object' || !node.children) {
      return [];
    }

    const stepIds = [];
    node.children.forEach((child) => {
      if (child.type === 'block') {
        const data = child.data;
        if (opts.detailed === true) {
          stepIds.push({
            key,
            sourceKey: data.key,
            stepId: data.stepId
          });
        } else {
          stepIds.push(data.stepId);
        }
      } else if (child.children && child.children.length > 0) {
        stepIds.push(...extractStepIds(child));
      }
    });

    return stepIds;
  };

  return extractStepIds(value?.root);
};

export default getLexicalDependencies;
